<template>
  <div class="addPrinter">
    <!-- 添加按钮 -->
    <div class="scan" v-if="scan" @click="handleScan">
      <van-icon name="scan" size="0.44rem" />
    </div>
    <van-form @submit="onSubmit" label-width="100">
    <!-- <van-cell title="设备编号" /> -->
      <van-field v-model="form.sn" label="设备编号" :maxlength="12" name="sn" placeholder="请输入3-12位的设备编号" />
      <!-- <van-cell title="密钥" /> -->
      <van-field v-model="form.key" label="密钥" name="key" placeholder="请输入密钥" />
      <van-field v-if="isShowStatus" name="status" label="启用状态">
        <template #input>
          <van-switch
            active-color="#31B158"
            v-model="form.status"
            size="24"
            @change="changeStatus"
          />
        </template>
      </van-field>
      <van-field name="is_auto" label="自动打印">
        <template #input>
          <van-switch active-color="#31B158" v-model.number="form.is_auto" size="24" />
        </template>
      </van-field>
      <van-field class="flex-b" name="print_num" label="打印(份数）">
        <template #input>
          <van-stepper v-model="form.print_num" max="5" />
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button
          round
          block
          type="info"
          color="#31B158"
          native-type="submit"
        >{{isShowStatus?"确认修改":"添加"}}</van-button>
      </div>
    </van-form>
    <div style="margin: 16px;" v-if="isShowStatus">
      <van-button
        round
        block
        type="danger"
        color="#FF0000"
        v-show="isShowBtn"
        @click="delPrinter"
      >删除</van-button>
    </div>
  </div>
</template>

<script>
import {
  printer_del,
  printer_set,
  printer_Detail
} from "@/api/work/mine/printer.js";
export default {
  name: "addPrinter",
  data() {
    return {
      form: {
        id: "",
        sn: "",//打印机编号
        key: "",//打印机密钥
        status: false,//启用状态
        type: 1,
        is_auto: false,//自动打印
        print_num: 1//打印份数
      },
      scan:false,
      isShowStatus: false,//判断是添加(true)还是修改(false)页面
      isShowBtn: false//判断删除按钮的显示还是隐藏
    };
  },

  created() {
    if (this.$route.query.id) {
      this.isShowStatus = true;
      this.getPrintDetail({ id: this.$route.query.id });//请求打印机详情
    } else {
      this.form.is_auto = true;
      this.form.status = true;
    }
    this.$navigation.on("back", (to, from) => {
      if (from.route.name == "public_scan") {
        var str = from.route.meta.backData.str
        var d = str.split(":")
        this.form.sn = d[0]
        this.form.key = d[1]
      }
    });
  },
  mounted() {
    try {
      if(plus){
        this.scan = true
      }
    } catch (error) {
      
    }
  },
  methods: {
    changeStatus(val) {
      this.isShowBtn = !val;
    },
    onSubmit(values) {
      if (!this.form.sn) {
        this.$toast("请输入设备编号");
        return false;
      }
      if ((this.form.sn + "").length >= 12 || (this.form.sn + "").length < 3) {
        this.$toast("设备编号格式不正确");
        return false;
      }
      if (!this.form.key) {
        this.$toast("请输入密钥");
        return false;
      }
      let obj = Object.assign({}, this.form);
      obj = this.conditionCheck(obj);
      printer_set(obj).then(res => {
        if (res.code == 200) {
          this.$toast.success(res.message);
          this.$router.go(-1);
        }
      });
    },
    conditionCheck(obj) {
      // bool值转换为number
      obj.is_auto = obj.is_auto ? 1 : 0;
      obj.status = obj.status ? 1 : 0;
      return obj;
    },
    //请求打印机详情
    getPrintDetail(val) {
      printer_Detail(val).then(res => {
        if (res.code == 200) {
          let obj = {};
          obj.id = res.data.id;
          obj.is_auto = res.data.is_auto ? true : false;
          obj.status = res.data.status ? true : false;
          obj.key = res.data.key;
          obj.print_num = res.data.print_num;
          obj.sn = res.data.sn;
          obj.type = res.data.type || 1;
          this.isShowBtn = !obj.status;
          this.form = obj;
        }
      });
    },
    //删除打印机
    delPrinter() {
      this.$dialog
        .confirm({
          message: "是否删除打印机订单"
        })
        .then(() => {
          let obj = Object.assign({}, this.form);
          obj = this.conditionCheck(obj);

          printer_del(obj).then(res => {
            if (res.code == 200) {
              this.$toast.success(res.message);
              setTimeout(() => {
                this.$toast.clear();
                this.$router.go(-1);
              }, 500);
            }
          });
        })
        .catch(() => {});
    },
    // 扫一扫
    handleScan(){
      this.$router.push({
        path:'/public/scan',
        query:{
          message:'请扫描正确的打印机二维码！',
          reg:"^[a-zA-z0-9]+:[a-zA-z0-9]+$"
        }
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id) {
      to.meta.title = "修改打印机配置";
    } else {
      to.meta.title = "添加打印机";
    }
    next();
  }
};
</script>
<style lang="less">
.addPrinter{
  position: relative;
  .scan{
    position: absolute;
    top: 0;
    width: 0.88rem;
    height: 0.88rem;
    right: 0.1rem;
    z-index: 99;
    font-size: 0.32rem;
    color: #31B158;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.addPrinter .van-cell .van-field__control {
  display: flex;
  justify-content: flex-end;
}
</style>
<style lang="less" scoped>
.addPrinter {
  position: relative;
}
</style>